module.exports = __webpack_public_path__ + "static/media/strongresults-logo.a04d225f.png";